import { useState, useCallback } from "react";
import { fetchWithAuth } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";
import { toastHandler } from "@/lib/ToastHandler";

export interface Country {
  id: number;
  name: string;
  short_name?: string;
  flag_url?: string;
}

export function useCountriesApi() {
  const [countries, setCountries] = useState<Country[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { getAccessToken } = useAuth();

  const fetchCountries = useCallback(async () => {
    setLoading(true);
    try {
      const token = await getAccessToken();
      const response = await fetchWithAuth("/branch/countries", token);
      const data: Country[] = Array.isArray(response)
        ? response
        : response?.data || [];
      setCountries(data);
      setError(null);
    } catch (err) {
      console.error("Error fetching countries:", err);
      setError("Error al obtener países");
      toastHandler({
        title: "Error",
        description: "Error al obtener países",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  }, [getAccessToken]);

  return { countries, loading, error, fetchCountries };
}
